// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__3DG7D","white":"Logo_white__2atuv","sending":"Logo_sending__2nCYj"};